import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../common/css/transmitter.css';
import {useInterval, parse_metrics_body, saveIfChange} from '../../common/app_common.js';
import {getApiDataQueryRange} from '../../common/fetch_api/data';
import {getApiEdgeIdMetrics} from '../../common/fetch_api/edge';
import {getApiAlertRulesId} from '../../common/fetch_api/alert';
import {TitleDetail, TermRefresh} from '../../common/component_common.js';
import {checkApiDataResult, getStartEndStep, makeResultData, makeChartData, updateChartData,
        valuesTimeDisp, ChartTime, DisplayMaxMinValue, timeTextChange, makeStlChartData,
        updateStlChartData, stlValuesTimeDisp, dateTimeFormat, updateErrorCountChartData,
        errorCountDisplay, calcStep} from './monitoring/monitoring_common.js';
import {areaChartOption, stlChartOption, lineChartOption, barChartOption} from './monitoring/chartsOptions';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Col from 'react-bootstrap/Col';
import {TermRefreshContext} from '../../pages/sites_list';

const TransmitterMonitoring = ({setPageName, siteInfo, edgeInfo}) =>
{
    let termInit = sessionStorage.getItem('term');
    const [term, setTerm] = useState(termInit ?? '1');
    sessionStorage.setItem('term', term);

    let refreshInit = sessionStorage.getItem('refresh');
    const [refresh, setRefresh] = useState(refreshInit ?? 5000);
    sessionStorage.setItem('refresh', refresh);

    if(!siteInfo)
    {
        siteInfo = JSON.parse(sessionStorage.getItem('siteInfo'));
    }

    if(!edgeInfo)
    {
        edgeInfo = JSON.parse(sessionStorage.getItem('edgeInfo'));
    }

    const [isStop, setIsStop] = useState(false);
    const [reload, setReload] = useState(false);
    const [isCalendar, setIsCalendar] = useState(false);

    const [metricsObj, setMetricsObj] = useState(null);

    const [update, setUpdate] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    // const [alertRules, setAlertRules] = useState(null);
    // useEffect(() =>
    // {
    //     Promise.resolve(getApiAlertRulesId(edgeInfo.id))
    //     .then(data =>
    //     {
    //         console.log(data)
    //         if( data )
    //         {
    //             if(data.alertRules && data.alertRules.length > 0)
    //             {
    //                 let alertRulesArr = [];
    //                 for(let item of data.alertRules)
    //                 {
    //                     let metric = item.metric;
    //                     let isEnabled = item.enabled;
    //                     let value = item.condition.right;
        
    //                     let alertRules = {
    //                         "metric": metric,
    //                         "enabled": isEnabled, 
    //                         "limit": value,
    //                     }
    //                     alertRulesArr.push(alertRules);
    //                 }
    //                 setAlertRules(alertRulesArr);
    //             }
    //         }
    //     });
    // }, [update]);

    useEffect(() =>
    {
        Promise.resolve(getApiEdgeIdMetrics(edgeInfo.id))
        .then(data =>
        {
            let parseBody = parse_metrics_body(data);
            setMetricsObj(parseBody.metrics);
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
            <div className="d-flex flex-wrap">
                <TitleDetail setPageName={setPageName} siteName={siteInfo.name} edgeTitle={edgeInfo.name} />
                <TermRefresh setTerm={setTerm} term={term} setRefresh={setRefresh} refresh={refresh} setIsStop={setIsStop} isStop={isStop} reload={reload} setReload={setReload} setIsCalendar={setIsCalendar} isCalendar={isCalendar}/>
            </div>
            <div className="d-flex flex-column mt-2">
                <div className="div-title">Information</div>
                <div className="d-flex flex-wrap">
                    {metricsObj && <Information metricsObj={metricsObj} />}
                    <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="d-flex flex-wrap">
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmOutputBitrateChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmFecOverheadChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="section chart">
                                    <div className="section-title">Error Count</div>
                                    <TmRtpErrorCountChart edgeId={edgeInfo.id} />
                                    <hr />
                                    <TmFecRepairCountChart edgeId={edgeInfo.id} />
                                </div>
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 space-section invisible"></div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmNetworkDelayChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmMndChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmMwBandwidthChart edgeId={edgeInfo.id} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-wrap">
                    {metricsObj && <RfInformation metricsObj={metricsObj} />}
                    <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="div-title">RF Monitoring</div>
                        <div className="d-flex flex-wrap">
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmRfRssiChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmRfMerChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmRfSnrChart edgeId={edgeInfo.id} />
                            </div>
                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                <TmRfFerChart edgeId={edgeInfo.id} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TermRefreshContext.Provider>
    )
}

export default TransmitterMonitoring;

const Information = ({metricsObj}) =>
{
    const [l1Time, setL1Time] = useState({month:'00', day:'00', year:'0000', time:'00:00:00', msec:'000'});
    const [utcTime, setUtcTime] = useState({month:'00', day:'00', year:'0000', time:'00:00:00', msec:'000'});
    const [utcDiffTime, setUtcDiffTime] = useState('-');
    
    const [ipAddress, setIpAddress] = useState('-');
    const [port, setPort] = useState('-');
    const [protocol, setProtocol] = useState('Protocol');

    useEffect( () => {
        if(metricsObj.hasOwnProperty('atsc3_l1_time_seconds'))
        {
            let l1TimeValue = metricsObj.atsc3_l1_time_seconds[0].value;
            let utcTimeValue = metricsObj.atsc3_utc_time_seconds[0].value;

            setL1Time(dateTimeFormat(metricsObj.atsc3_l1_time_seconds[0].value));
            setUtcTime(dateTimeFormat(metricsObj.atsc3_utc_time_seconds[0].value));

            setUtcDiffTime((Number(l1TimeValue) - Number(utcTimeValue)).toFixed(3));
        }

        if(metricsObj.hasOwnProperty('atsc3_recv_info'))
        {
            setIpAddress(metricsObj.atsc3_recv_info[0].labels.address);
            setPort(metricsObj.atsc3_recv_info[0].labels.port);
            setProtocol((metricsObj.atsc3_recv_info[0].labels.protocol).toUpperCase());
        }
    }, [metricsObj]);

    return (
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 information-area">
            <div className="section l1Time">
                <div className="section-title">L1 Time</div>
                <div className="value-label x-lg">
                    {l1Time.month}/{l1Time.day}/{l1Time.year} {l1Time.time}.<span style={{fontSize: '1rem'}}>{l1Time.msec}</span>
                </div>
                <div className="d-flex justify-content-between mt-2">
                    <div className="label md">UTC</div>
                    <div className="value-label md">
                        {utcTime.month}/{utcTime.day}/{utcTime.year} {utcTime.time}.<span style={{fontSize: '0.6rem'}}>{utcTime.msec}</span>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="label md">UTC Different</div>
                    <div className="value-label md">{utcDiffTime}sec</div>
                </div>
            </div>
            <div className="section stl">
                <div className="section-title">{protocol}</div>
                <div className="value-label x-lg">{ipAddress} : <span style={{fontSize: '1rem'}}>{port}</span></div>
            </div>
            <div className="d-flex">
                <FecColL metricsObj={metricsObj} />
                <FecRowL metricsObj={metricsObj} />
                <Wakeup metricsObj={metricsObj} />
            </div>
            <div className="d-flex">
                <TxidSeed metricsObj={metricsObj} />
                <TxidInjectionLevel metricsObj={metricsObj} />
            </div>
            <div className="d-flex">
                <L1dBsid metricsObj={metricsObj} />
                <TxidGroup metricsObj={metricsObj} />
            </div>
            <div className="d-flex">
                <L1dVersion metricsObj={metricsObj} />
                <Frequency metricsObj={metricsObj} />
            </div>
            <div className="d-flex">
                <NetDelayMax metricsObj={metricsObj} />
                <NetDelayMin metricsObj={metricsObj} />
            </div>
        </div>
    )
}

const RfInformation = ({metricsObj}) =>
{
    return (
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 rf-information-area">
            <div className="div-title">&nbsp;</div>
            <div className="d-flex">
                <RfLock metricsObj={metricsObj} />
                <GpsLock metricsObj={metricsObj} />
            </div>
            <div className="d-flex">
                <TimeSyncMode metricsObj={metricsObj} /> 
                <TimeSyncState metricsObj={metricsObj} /> 
            </div>
            <div className="d-flex">
                <TimeSyncOffset metricsObj={metricsObj} />
            </div>
        </div>
    )
}

export const FecColL = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_fec_col') ? metricsObj.atsc3_fec_col[0].value : '-');

    }, [metricsObj]);
    return (
        <TmInfomationSection colSize={4} title="FEC Col(L)" value={value}/>
    )
}

export const FecRowL = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_fec_row') ? metricsObj.atsc3_fec_row[0].value : '-');

    }, [metricsObj]);
    
    return (
        <TmInfomationSection colSize={4} title="FEC Row(L)" value={value}/>
    )
}

export const Wakeup = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_eas_wakeup_bit') ? Number(metricsObj.atsc3_eas_wakeup_bit[0].value).toString(2).padStart(2, '0') : '-');

    }, [metricsObj]);

    return (
        <TmInfomationSection colSize={4} title="Wakeup" value={value}/>
    )
}

export const TxidSeed = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_eas_wakeup_bit') ? metricsObj.atsc3_txid_seed[0].value : '-');

    }, [metricsObj]);
    
    return (
        <TmInfomationSection colSize={6} title="TXID Seed" value={value}/>
    )
}

export const TxidInjectionLevel = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            let txidInjectionValue = '-';
    
            if(metricsObj.hasOwnProperty('atsc3_txid_injection_level'))
            {
                if(metricsObj.atsc3_txid_injection_level[0].value === '0')
                {
                    txidInjectionValue = 'Off';
                }
                else
                {
                    txidInjectionValue = metricsObj.atsc3_txid_injection_level[0].value;
                }
            }
    
            saveIfChange(setValue, txidInjectionValue);
        }
        else
        {
            saveIfChange(setValue, '-');
        }

    }, [metricsObj]);
    
    return (
        <TmInfomationSection colSize={6} title="TXID Injection Level" value={value}/>
    )
}

export const L1dBsid = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            saveIfChange(setValue, metricsObj.hasOwnProperty('atsc3_l1d_bsid') ? metricsObj.atsc3_l1d_bsid[0].value : '-');
        }
        else
        {
            saveIfChange(setValue, '-');
        }

    }, [metricsObj]);
    
    return (
        <TmInfomationSection colSize={6} title="L1D BSID" value={value}/>
    )
}

export const TxidGroup = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            saveIfChange(setValue, metricsObj.hasOwnProperty('atsc3_txid_group') ? metricsObj.atsc3_txid_group[0].value : '-');
        }
        else
        {
            saveIfChange(setValue, '-');
        }

    }, [metricsObj]);
    
    return (
        <TmInfomationSection colSize={6} title="TXID Group" value={value}/>
    )
}

export const L1dVersion = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_l1d_version') ? metricsObj.atsc3_l1d_version[0].value : '-');

    }, [metricsObj]);

    return (
        <TmInfomationSection colSize={6} title="L1D Version" value={value}/>
    )
}

export const Frequency = ({metricsObj}) =>
{
    const [value, setValue] = useState('- Hz');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            saveIfChange(setValue, metricsObj.hasOwnProperty('atsc3_tuner_frequency_mhz') ? `${metricsObj.atsc3_tuner_frequency_mhz[0].value*1000000}Hz` : '- Hz');
        }
        else
        {
            saveIfChange(setValue, '- Hz');
        }

    }, [metricsObj]);

    return (
        <TmInfomationSection colSize={6} title="Frequency" value={value}/>
    )
}

export const NetDelayMax = ({metricsObj}) =>
{
    const [value, setValue] = useState('- ms');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_network_delay_24h_max_ms') ? `${metricsObj.atsc3_network_delay_24h_max_ms[0].value}ms` : '- ms');

    }, [metricsObj]);

    return (
        <TmInfomationSection colSize={6} title="Net Delay Max24h" value={value}/>
    )
}

export const NetDelayMin = ({metricsObj}) =>
{
    const [value, setValue] = useState('- ms');
    
    useEffect( () =>
    {
        setValue(metricsObj.hasOwnProperty('atsc3_network_delay_24h_min_ms') ? `${metricsObj.atsc3_network_delay_24h_min_ms[0].value}ms` : '- ms');

    }, [metricsObj]);

    return (
        <TmInfomationSection colSize={6} title="Net Delay Min24h" value={value}/>
    )
}

export const TmInfomationSection = ({colSize, title, value}) =>
{
    return (
        <Col size={colSize}>
            <div className="section">
                <div className="section-title">{title}</div>
                <div className="section-body">
                    <div className="value-label x-lg">{value}</div>
                </div>
            </div>
        </Col>
    )
}

export const RfLock = ({metricsObj}) =>
{
    const [textColor, setTextColor] = useState('');
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            if(metricsObj.hasOwnProperty('atsc3_tuner_lock'))
            {
                let data = metricsObj.atsc3_tuner_lock[0].value;
    
                if( data === '0' )
                {
                    saveIfChange(setValue, 'Fail');
                    saveIfChange(setTextColor, 'text-danger');
                }
                else if( data === '1' )
                {
                    saveIfChange(setValue, 'OK');
                    saveIfChange(setTextColor, '');
                };
            }
            else
            {
                saveIfChange(setValue, '-');
                saveIfChange(setTextColor, '');
            }
        }
    }, [metricsObj]);

    return (
        <Col size={6}>
            <div className="section" >
                <div className="section-title">RF Lock</div>
                <div className={`value-label x-lg ${textColor}`}>{value}</div>
            </div>
        </Col>
    )
}

export const GpsLock = ({metricsObj}) =>
{
    const [textColor, setTextColor] = useState('');
    const [value, setValue] = useState('-');
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            if(metricsObj.hasOwnProperty('atsc3_gps_lock'))
            {
                let data = metricsObj.atsc3_gps_lock[0].value;
    
                if( data === '0' )
                {
                    saveIfChange(setValue, 'Fail');
                    saveIfChange(setTextColor, 'text-danger');
                }
                else if( data === '1' )
                {
                    saveIfChange(setValue, 'OK');
                    saveIfChange(setTextColor, '');
                };
            }
            else
            {
                saveIfChange(setValue, '-');
                saveIfChange(setTextColor, '');
            }
        }
    }, [metricsObj]);
    
    return (
        <Col size={6}>
            <div className="section" >
                <div className="section-title">GPS Lock</div>
                <div className={`value-label x-lg ${textColor}`}>{value}</div>
            </div>
        </Col>
    )
}

export const TimeSyncMode = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');

    useEffect( () =>
    {
        if(metricsObj.hasOwnProperty('atsc3_time_sync'))
        {
            let data = metricsObj.atsc3_time_sync[0].labels.type;
            setValue(data.toUpperCase());
        };
    }, [metricsObj]);
    
    return (
        <div className="col-6">
            <div className="section time-sync-mode">
                <div className="section-title">TimeSync Mode</div>
                <div className="value-label x-lg">{value}</div>
            </div>
        </div>
    )
}

export const TimeSyncState = ({metricsObj}) =>
{
    const [value, setValue] = useState('-');
    const [subValue, setSubValue] = useState('');
    
    useEffect( () =>
    {
        if(metricsObj.hasOwnProperty('atsc3_time_sync'))
        {
            let data = metricsObj.atsc3_time_sync[0].value;
            setValue('Lock');

            if(data)
            {
                setSubValue('(slave)');
            }
        }
    }, [metricsObj]);
    
    return (
        <Col size={6}>
            <div className="section time-sync-state">
                <div className="section-title">TimeSync State</div>
                <div className="value-label x-lg">{value}</div>
                <div className="value-label">{subValue}</div>
            </div>
        </Col>
    )
}

export const TimeSyncOffset = ({metricsObj}) =>
{
    const [value, setValue] = useState('- ns');
    
    useEffect( () =>
    {
        if(metricsObj.hasOwnProperty('atsc3_time_sync_offset_ns'))
        {
            let data = metricsObj.atsc3_time_sync_offset_ns[0].value;
            setValue(`${data}ns`);
        };
    }, [metricsObj]);

    return (
        <Col size={6}>
            <div className="section time-sync-mode">
                <div className="section-title">TimeSync Offset</div>
                <div className="value-label x-lg">{value}</div>
            </div>
        </Col>
    )
}

export const TmOutputBitrateChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);
    
    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(stlChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        stlMb: '00.00',
        fecMb: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`atsc3_stl_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`atsc3_stl_fec_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let stlResult = data1.data.result[0].values;
                let fecResult = data2.data.result[0].values;

                let stlValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, stlResult);
                let fecValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, fecResult);

                
                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = stlValues[stlValues.length - 1][0];

                    let data = makeStlChartData(stlValues, fecValues);

                    // let limitValue = getLimitValue("digicaster_s_out_bytes", "stlOutputBitrateSection") / 1000000;

                    // let chartMaxVal = chartMaxValue(limitValue, data.fecDataArr);

                    setChartOptions({...chartOptions, series: [{data: data.fecDataArr},{data: data.stlDataArr}]});
                }
                else if(!setInit.current)
                {
                    updateStlChartData(chartRef.current.chart,  stlValues, fecValues, chartLastTime.current);

                    chartLastTime.current = stlValues[stlValues.length - 1][0];
                }

                setDisplayValues(stlValuesTimeDisp(stlValues, fecValues));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">Output Bitrate</div>
            <div className="d-flex justify-content-between">
                <div className="label lg"><span className="label-bar stl"></span>STL</div>
                <div className="value-label lg">{displayValues.stlMb}Mbps</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label lg"><span className="label-bar stl-fec"></span>STL with FEC</div>
                <div className="value-label lg">{displayValues.fecMb}Mbps</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 124 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue label="(STL)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'Mbps'} />
        </div>
    )
}

export const TmFecOverheadChart = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(lineChartOption('Overhead', 0, 100, null ,null, '%', [8, null, 5, 25], dash));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const [subValue, setSubValue] = useState('00.00Mbps');

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`atsc3_fec_overhead_percent{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`atsc3_stl_fec_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let mainResult = data1.data.result[0].values;
                let subResult = data2.data.result[0].values;

                let mainValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, mainResult);
                let subValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, subResult);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = mainValues[mainValues.length - 1][0];

                    let data = makeChartData(mainValues);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart,  mainValues, chartLastTime.current);

                    chartLastTime.current = mainValues[mainValues.length - 1][0];
                }

                setSubValue(`${(subValues[subValues.length - 1][1] * 8 / 1000000).toFixed(2)}Mbps`);

                setDisplayValues(valuesTimeDisp(mainValues, 'fecOverhead'));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">FEC Overhead</div>
            <div className="d-flex justify-content-between">
                <div className={`label ${dash==='dash'?'md':'lg'}`}>Overhead</div>
                <div className={`value-label ${dash==='dash'?'md':'lg'}`}>{displayValues.mainValue}% ({subValue})</div>
            </div>
            <div className="bar-graph fecOverhead">
                <div className="limit-value">0%</div>
                <div className="limit-text min">min</div>
                <div className="limit-text max">max</div>
                <div className="limit-bar min"></div>
                <div className="limit-bar max"></div>
                <div className="bar-wrap">
                    <div className="main-bar"></div>
                </div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 88 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue label="(FEC)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'%'} />
        </div>
    )
}

export const TmRtpErrorCountChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(barChartOption('RTP Error', null, 'Count', [null, 10, 5, null]));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);

        Promise.resolve(getApiDataQueryRange(`rate(atsc3_rtp_loss_sum{id="${edgeId}"}[${4*calcStep('1')}s])`, timeOption.start, timeOption.end, timeOption.step))
        .then( data =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let dataArray = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: dataArray}]});
                }
                else if(!setInit.current)
                {
                    let value = (Math.round(result[result.length - 1][1] * 100) / 100);

                    updateErrorCountChartData(chartRef.current.chart,  value, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }
                
                setDisplayValues(errorCountDisplay(result));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="label lg">RTP Error Count</div>
                <div className="value-label lg">{displayValues.mainValue}Count</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 62 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
        </>
    )
}

export const TmFecRepairCountChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(barChartOption('FEC Repair', null, 'Count', [null, 10, 5, null]));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`rate(atsc3_fec_repair_sum{id="${edgeId}"}[${4*calcStep('1')}s])`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let dataArray = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: dataArray}]});
                }
                else if(!setInit.current)
                {
                    let value = (Math.round(result[result.length - 1][1] * 100) / 100);

                    updateErrorCountChartData(chartRef.current.chart,  value, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];

                }

                setDisplayValues(errorCountDisplay(result));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="label lg">FEC Repair Count</div>
                <div className="value-label lg">{displayValues.mainValue}Count</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 62 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
        </>
    )
}

export const TmNetworkDelayChart = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(lineChartOption('Network Delay', 0, 10, [0, 10], null, 'ms', [5, null, 5, 20], dash));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`atsc3_network_delay_ms{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section network-delay chart">
            <div className="section-title">Network Delay</div>
            <div className={`value-label ${dash==='dash'?'md':'x-lg'}`}>{displayValues.mainValue}ms</div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 128 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'ms'} />
        </div>
    )
}

export const TmMndChart = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(lineChartOption('MND', 0, 600, null, 100, 'ms', [5, null, 5, 30], dash));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`atsc3_mnd_ms{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section mnd chart">
            <div className="section-title">MND</div>
            <div className={`value-label ${dash==='dash'?'md':'x-lg'}`}>{displayValues.mainValue}ms</div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 128 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'ms'} />
        </div>
    )
}

export const TmMwBandwidthChart = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(lineChartOption('Bandwidth', 0, 100, null, null, '%', [8, null, 5, 25], dash));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const [subValue, setSubValue] = useState(0);
    const [markValue, setMarkValue] = useState(0);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`atsc3_mw_bandwidth_percent{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`atsc3_mw_bandwidth_info{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let mainResult = data1.data.result[0].values;
                let subResult = Number(data2.data.result[0].metric.value);

                let mainValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, mainResult);
                // let subValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, subResult);
                // let subValue = document.querySelector(".mwBandwidth .mark-text.value").textContent = `${subResult}Mbps`;

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = mainValues[mainValues.length - 1][0];

                    let data = makeChartData(mainValues);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart,  mainValues, chartLastTime.current);

                    chartLastTime.current = mainValues[mainValues.length - 1][0];
                }

                setMarkValue(subResult);
                // setSubValue(`${(subValues[subValues.length - 1][1] * 8 / 1000000).toFixed(2)}Mbps`);

                setSubValue((Number(mainValues[mainValues.length - 1][1]) * markValue / 100).toFixed(2))

                setDisplayValues(valuesTimeDisp(mainValues, 'mwBandwidth'));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">MW Bandwidth</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">CurrentBandwidth</div>
                <div className="value-label lg">{displayValues.mainValue}% ({subValue}Mbps)</div>
            </div>
            <div className="bar-graph mwBandwidth">
                <div className="bandwidth-max-value">{markValue}Mbps</div>
                <div className="limit-value">0%</div>
                <div className="limit-text min">min</div>
                <div className="limit-text max">max</div>
                <div className="limit-bar min"></div>
                <div className="limit-bar max"></div>
                <div className="bar-wrap">
                    <div className="main-bar"></div>
                </div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 88 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue label="(FEC)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'%'} />
        </div>
    )
}

export const TmRfRssiChart = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(lineChartOption('RSSI', -99, 0, [-99, 0], null, 'dBm',[15, null, 5, 25], dash));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`atsc3_tuner_rssi_dbm{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        });
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">RF Measure RSSI</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">RSSI</div>
                <div className="value-label lg">{displayValues.mainValue}dBm</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 144 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'dBm'} />
        </div>
    )
}

export const TmRfMerChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(areaChartOption('MER', 40, 'dB'));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`atsc3_tuner_mer_db{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        });
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">RF Measure MER</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">MER</div>
                <div className="value-label lg">{displayValues.mainValue}dB</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 144 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'dB'} />
        </div>
    )
}

export const TmRfSnrChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(areaChartOption('SNR', 40, 'dB'));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`atsc3_tuner_snr_db{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        });
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">RF Measure SNR</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">SNR</div>
                <div className="value-label lg">{displayValues.mainValue}dB</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 144 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'dB'} />
        </div>
    )
}

export const TmRfFerChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(barChartOption('FER', 100, '', [15, 10, 1, 10]));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`rate(atsc3_tuner_fer_sum{id="${edgeId}"}[60s])`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeChartData(result);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateChartData(chartRef.current.chart, result, chartLastTime.current);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result, 'rfFer'));
            }
        });
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">RF Measure FER</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">FER</div>
                <div className="value-label lg">{displayValues.mainValue}</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 144 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={''} />
        </div>
    )
}

export const StlInfoForDashBoard = ({metricsObj}) =>
{
    const [ipAddress, setIpAddress] = useState('-');
    const [port, setPort] = useState('-');
    const [protocol, setProtocol] = useState('Protocol');

    useEffect( () => {
        if(metricsObj.hasOwnProperty('atsc3_recv_info'))
        {
            setIpAddress(metricsObj.atsc3_recv_info[0].labels.address);
            setPort(metricsObj.atsc3_recv_info[0].labels.port);
            setProtocol((metricsObj.atsc3_recv_info[0].labels.protocol).toUpperCase());
        }
    }, [metricsObj]);

    return (
        <>
            <div className="div-title">STL Information</div>
            <div className="information-area">
                <div className="section stl">
                    <div className="section-title">{protocol}</div>
                    <div className="value-label x-lg">{ipAddress} : <span style={{fontSize: '1rem'}}>{port}</span></div>
                </div>
                <div className="d-flex">
                    <FecColL metricsObj={metricsObj} />
                    <FecRowL metricsObj={metricsObj} />
                    <Wakeup metricsObj={metricsObj} />
                </div>
                <div className="d-flex">
                    <TxidSeed metricsObj={metricsObj} />
                    <TxidInjectionLevel metricsObj={metricsObj} />
                    <TxidGroup metricsObj={metricsObj} />
                </div>
                <div className="d-flex">
                    <L1dBsid metricsObj={metricsObj} />
                    <L1dVersion metricsObj={metricsObj} />
                </div>
            </div>
        </>
    )
}

export const StlTimeInfoForDashBoard = ({metricsObj}) =>
{
    const [l1Time, setL1Time] = useState({month:'00', day:'00', year:'0000', time:'00:00:00', msec:'000'});
    const [utcTime, setUtcTime] = useState({month:'00', day:'00', year:'0000', time:'00:00:00', msec:'000'});
    const [utcDiffTime, setUtcDiffTime] = useState('-');

    useEffect( () => {
        if(metricsObj.hasOwnProperty('atsc3_l1_time_seconds'))
        {
            let l1TimeValue = metricsObj.atsc3_l1_time_seconds[0].value;
            let utcTimeValue = metricsObj.atsc3_utc_time_seconds[0].value;

            setL1Time(dateTimeFormat(metricsObj.atsc3_l1_time_seconds[0].value));
            setUtcTime(dateTimeFormat(metricsObj.atsc3_utc_time_seconds[0].value));

            setUtcDiffTime((Number(l1TimeValue) - Number(utcTimeValue)).toFixed(3));
        }
    }, [metricsObj]);

    return (
        <>
            <div className="div-title">STL Time Information</div>
            <div className="information-area">
                <div className="section l1Time">
                    <div className="section-title">L1 Time</div>
                    <div className="value-label x-lg">
                        {l1Time.month}/{l1Time.day}/{l1Time.year} {l1Time.time}.<span style={{fontSize: '1rem'}}>{l1Time.msec}</span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                        <div className="label md">UTC</div>
                        <div className="value-label md">
                            {utcTime.month}/{utcTime.day}/{utcTime.year} {utcTime.time}.<span style={{fontSize: '0.6rem'}}>{utcTime.msec}</span>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="label md">UTC Different</div>
                        <div className="value-label md">{utcDiffTime}sec</div>
                    </div>
                </div>
                <div className="d-flex">
                    <NetDelayMax metricsObj={metricsObj} />
                    <NetDelayMin metricsObj={metricsObj} />
                </div>
            </div>
        </>
    )
}

export const TunerGpsTime = ({metricsObj}) => {
    
    const [timeSync, setTimeSync] = useState('-');
    const [timeState, setTtimeState] = useState('-');
    const [timeStateSub, setTimeStateSub] = useState('');
    const [timeOffset, setTimeOffset] = useState('- ns');
    
    useEffect( () =>
    {
        if(metricsObj.hasOwnProperty('atsc3_time_sync'))
        {
            let data = metricsObj.atsc3_time_sync[0].value;
            setTimeSync(data.toUpperCase());
            
            setTtimeState('Lock');
            if(data)
            {
                setTimeStateSub('slave');
            }
        };
        
        if(metricsObj.hasOwnProperty('atsc3_time_sync_offset_ns'))
        {
            let data = metricsObj.atsc3_time_sync_offset_ns[0].value;
            setTimeOffset(`${data}ns`);
        };
    }, [metricsObj]);

    return (
        <>
            <div className="div-title">Tuner & GPS &Time</div>
            <div className="information-area">
                <div className="d-flex">
                    <Frequency metricsObj={metricsObj} />
                    <RfLock metricsObj={metricsObj} />
                    <GpsLock  metricsObj={metricsObj} />
                </div>
                <div className="d-flex">
                    <Col size={4}>
                        <div className="section time-sync-mode">
                            <div className="section-title">TimeSync Mode</div>
                            <div className="value-label x-lg">{timeSync}</div>
                        </div>
                    </Col>
                    <Col size={4}>
                        <div className="section time-sync-state">
                            <div className="section-title">TimeSync State</div>
                            <div className="value-label x-lg">{`${timeState} / ${timeStateSub}`}</div>
                        </div>
                    </Col>
                    <Col size={4}>
                        <div className="section time-sync-mode">
                            <div className="section-title">TimeSync Offset</div>
                            <div className="value-label x-lg">{timeOffset}</div>
                        </div>
                    </Col>
                </div>
            </div>
        </>
    )
}